import Registry from './registry'

const registerPart = (part, options) => Registry.register(part, options, true)
const getPart = (part) => Registry.get(part)
const listParts = () => Registry.list()

export default {
  registerPart,
  getPart,
  listParts
}

// const registry = {
//   types: {},
//   groups: {}
// }

// export const registerPart = (part, options) => {
//   const exists = registry[part]
//   if (exists) {
//     throw new Error(`Part ${part} is already registered.`)
//   }

//   registry.types[part] = options
//   // init array
//   registry.groups[options.group].push(part)
// }

// export const getPart = part => registry.types[part]

// export const listParts = () => {
//   Object.keys(registry.groups).map(groupName => {
//     return {
//       label: groupName,
//       options: registry.groups[groupName].map(type => {
//         return {value: type, text: registry.types[type].name}
//       })
//     }
//   })
// }



// WEBPACK FOOTER //
// ./app/fridge.js